// extracted by mini-css-extract-plugin
export default {"primaryButton":"PrimaryButton_primaryButton__llpMg"};